import { render } from "./SignOutButton.vue?vue&type=template&id=799dfdd8&scoped=true"
import script from "./SignOutButton.vue?vue&type=script&lang=js"
export * from "./SignOutButton.vue?vue&type=script&lang=js"

import "./SignOutButton.vue?vue&type=style&index=0&id=799dfdd8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-799dfdd8"]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn});
